
		<div
			class="form-group"
			[formGroup]="OBJ_form_group"
			[ngClass]="{'has-error': isInvalid()}">
			<label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
                <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
			<div class="col-lg-8">
				<tig-dual-list-box
					[formControlName]="OBJ_field_config.name"
					[disabled]="OBJ_field_config?.readonly"
					[source]="OBJ_field_config.options"
					[config]="OBJ_dual_list_config"
					(destinationChange)="selected($event)"
				></tig-dual-list-box>
				<div class="tig-hint" *ngIf="OBJ_field_config.note">
					<span>{{ OBJ_field_config.note|translate}}</span>
				</div>
                <tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
			</div>
		</div>
	